import { render } from "./CompatibilityGrid.vue?vue&type=template&id=004f220c&scoped=true"
import script from "./CompatibilityGrid.vue?vue&type=script&lang=js"
export * from "./CompatibilityGrid.vue?vue&type=script&lang=js"

import "./CompatibilityGrid.vue?vue&type=style&index=0&id=004f220c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004f220c"]])

export default __exports__